module.exports = __webpack_public_path__ + "static/media/400057_01.b06eaab2.png";